import { render, staticRenderFns } from "./AscensosPage.vue?vue&type=template&id=9aef1862"
import script from "./AscensosPage.js?vue&type=script&lang=js&external"
export * from "./AscensosPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports